"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseOptionsSelector = exports.ResponseOptionsWrapper = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var constants_1 = __importDefault(require("../../constants"));
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var common_1 = require("../common");
var _1 = require("./");
var NaOptionContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
NaOptionContainer.displayName = 'NaOptionContainer';
exports.ResponseOptionsWrapper = (0, styled_components_1.default)('div').attrs({
    className: 'tws-custom-response-options-selector',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin: 40px 0;\n"], ["\n\tmargin: 40px 0;\n"])));
var ResponseOptionsSelector = /** @class */ (function (_super) {
    __extends(ResponseOptionsSelector, _super);
    function ResponseOptionsSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.HandleNaOptionChange = function (checked) {
            var HandleNaOptionChange = _this.props.HandleNaOptionChange;
            if (HandleNaOptionChange) {
                HandleNaOptionChange(checked);
            }
        };
        return _this;
    }
    ResponseOptionsSelector.prototype.render = function () {
        var _a = this.props, changeResponseOptionTypeInstructText = _a.changeResponseOptionTypeInstructText, chooseResponseOptionInstructText = _a.chooseResponseOptionInstructText, validationResult = _a.validationResult, libraryResponseOptionGroups = _a.libraryResponseOptionGroups, loading = _a.loading, naOption = _a.naOption, showNaOption = _a.showNaOption, questionId = _a.questionId, questionType = _a.questionType, sectionContainer = _a.sectionContainer, sectionHeaderText = _a.sectionHeaderText, sourceResponseOptionGroupId = _a.sourceResponseOptionGroupId;
        var errors = validationResult ? validationResult.errors || [] : [];
        var responseOptionGroupCodes = constants_1.default.CUSTOMQUESTION_RESPONSEOPTIONGROUP_CODES;
        if (this.props.additionalResponseOptionGroupCodes) {
            responseOptionGroupCodes = constants_1.default.CUSTOMQUESTION_RESPONSEOPTIONGROUP_CODES.concat(this.props.additionalResponseOptionGroupCodes);
        }
        var Container = sectionContainer ? sectionContainer : common_1.Section;
        return (React.createElement(Container, { id: 'choose-custom-responseoptions', sectionHeader: sectionHeaderText || contentConstants_1.default.SECTIONHEADERS_CUSTOM_QUESTION_CHOOSE_RESPONSEOPTION },
            React.createElement(common_1.ColFull, null,
                chooseResponseOptionInstructText || contentConstants_1.default.INSTRUCTIONALTEXT_CUSTOMQUESTION_CHOOSE_RESPONSEOPTION,
                ' ',
                React.createElement("strong", null, changeResponseOptionTypeInstructText || contentConstants_1.default.INSTRUCTIONALTEXT_CUSTOMQUESTION_RESPONSEOPTION_CHANGE_TYPE)),
            loading && (React.createElement(common_1.LoadingWrapper, null,
                React.createElement(aon_tws_common_ui_1.Loading, { height: '70px', width: '70px' }))),
            !loading && (React.createElement(React.Fragment, null,
                React.createElement(exports.ResponseOptionsWrapper, null,
                    React.createElement(_1.ResponseOptionGroupRadioList, { questionType: questionType, selected: sourceResponseOptionGroupId, responseOptionGroups: libraryResponseOptionGroups, onChange: this.props.HandleResponseOptionGroupChange, setOpenEnded: this.props.HandleSetOpenEnded, setTextBox: this.props.HandleSetTextBox, hasBeenSaved: questionId !== undefined, errorMsg: errors[0], responseOptionGroupCodes: responseOptionGroupCodes })),
                showNaOption && (React.createElement(NaOptionContainer, null,
                    React.createElement(aon_tws_common_ui_1.Checkbox, { label: contentConstants_1.default.CUSTOM_RESPONSEOPTION_NA_OPTION_TEXT, checked: naOption, onChange: this.HandleNaOptionChange })))))));
    };
    return ResponseOptionsSelector;
}(React.Component));
exports.ResponseOptionsSelector = ResponseOptionsSelector;
var templateObject_1, templateObject_2;
